import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { TipologiaUtente } from '../model/utente/utente';
import { AppConstants } from 'src/environments/constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {


  constructor(private readonly authService: AuthService, private readonly router: Router){
  }
  
    canActivate(
      route: ActivatedRouteSnapshot): Observable<boolean> | UrlTree | boolean{
        if (route.url[0].path === 'admin-page') {
          return this.canActivateAdmin();
        }
        return this.authService.isAuthenticated$;
    }

    canActivateAdmin(): boolean | UrlTree {
        const isAdmin = this.authService.getUtenteLoggato().tipologiaUtente === TipologiaUtente.ADMIN;
        if (!isAdmin) {
          return this.router.createUrlTree([AppConstants.UTENTE_NON_ABILITATO_ROUTE]);
        }
        return true;
    }
  
}
